<div class="flex gap-2 align-middle">
     <button class="flex flex-row group items-center justify-center gap-2 text-faded-70 hover:cursor-pointer hover:text-faded-90" (click)="onProfileIconClicked()">
        @if (username) {
            <notification-bubble [display]="hasNotifications">
                <avatar [username]="username" [small]="true"></avatar>
            </notification-bubble>
            <div class="hidden sm:block">
                {{ username }}
            </div>
        } @else {
            <svg class="size-6 fill-none stroke-faded-70 group-hover:stroke-faded-90" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="profileIconSvg" />
            </svg>
        }
    </button>
</div>